const styles = (theme) => ({
  documentStyle: {
    textAlign: 'left',
    overflow: 'hidden',
    // General tag styles
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      marginTop: 0,
      fontFamily: 'Calibre',
      fontWeight: 400,
      marginBottom: theme.spacing.unit * 2,
    },
    '& h1': {
      fontSize: '1.5625rem',
    },
    '& h2': {
      fontSize: '1.4375rem',
    },
    '& h3': {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    '& h4': {
      fontSize: '1.125rem',
      fontWeight: 500,
    },
    '& h5': {
      fontSize: '1.0625rem',
    },
    '& h6': {
      fontSize: '1rem',
    },
    '& p:last-child': {
      marginBottom: 0,
    },
    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },
    '& strong': {
      fontWeight: 500,
    },
    '& ul, & ol, & p': {
      marginTop: 0,
      marginBottom: theme.spacing.unit * 2,
    },
    '& ul li, & ol li': {
      marginBottom: theme.spacing.unit,
    },
    '& table': {
      borderSpacing: 0,
      marginBottom: theme.spacing.unit * 2,
      width: '100%',
      display: 'table',
      border: `1px solid ${theme.palette.border.light}`,
      borderCollapse: 'collapse',
    },
    '& table td': {
      borderBottom: `1px solid ${theme.palette.border.light}`,
      padding: theme.spacing.unit * 0.5,
    },
    // Text styles
    '& .text-center': {
      textAlign: 'center',
    },
    '& .text-right': {
      textAlign: 'right',
    },
    '& .text-justify': {
      textAlign: 'justify',
    },
    '& .largeBody': {
      fontSize: '1.250rem',
      fontFamily: 'Calibre',
      [theme.breakpoints.up('md')]: {
        fontSize: '1.4375rem',
      },
    },
    '& .mediumBody': {
      fontSize: '1.125rem',
      fontFamily: 'Calibre',
    },
    // Image styles
    '& img, & .captionImage': {
      [theme.breakpoints.down('sm')]: {
        margin: '0 auto',
        display: 'block',
      },
    },
    '& .left:not(.leftAlone)': {
      [theme.breakpoints.up('md')]: {
        float: 'left',
      },
    },
    '& .leftAlone': {
      [theme.breakpoints.up('md')]: {
        float: 'none',
        display: 'block',
      },
    },
    '& .right:not(.rightAlone)': {
      [theme.breakpoints.up('md')]: {
        float: 'right',
      },
    },
    '& .rightAlone': {
      [theme.breakpoints.up('md')]: {
        float: 'none',
        margin: '0 0 0 auto',
        display: 'block',
      },
    },
    '& .center': {
      display: 'block',
      margin: '0 auto',
    },
    '& img.center, & img.left, & img.right, & img.leftAlone, & img.rightAlone':
      {
        marginTop: 20,
        marginBottom: 20,
        [theme.breakpoints.up('md')]: {
          marginTop: 25,
          marginBottom: 25,
        },
      },
    '& img.left, & div.left': {
      [theme.breakpoints.up('md')]: {
        marginRight: 30,
      },
    },
    '& img.right, & div.right': {
      [theme.breakpoints.up('md')]: {
        marginLeft: 30,
      },
    },
    '& .captionImage': {
      maxWidth: '100%',
    },
    '& .captionImage .caption:last-child': {
      marginTop: -(theme.spacing.unit * 2),
      marginBottom: 20,
      [theme.breakpoints.up('md')]: {
        marginBottom: 25,
      },
    },
  },
});

export default styles;
